<script setup lang="ts">
const modalsStore = useModalsStore();
const props = defineProps<{
    title: string,
    desc: string,
    items: Array<{
        title: string,
        desc: string,
        img: string
    }>
}>();
const featureStyles = [
  { state: 'first', vairant: 'secondary' },
  { state: 'second', vairant: 'white' },
  { state: 'third', vairant: 'white' },
  { state: 'fourth', vairant: 'primary' },
] as const;


function handleOpenModal() {
  modalsStore.openModal('CTA');
};
</script>

<template>
    <SectionsBase id="features" class="container">
      <ChipsDivider>ویژگی‌ها</ChipsDivider>
      <h2>{{ props.title }}</h2>
      <p class="text-body1-semibold text-gray-400 text-center my-6">{{ props.desc }}</p>
      <div class="grid grid-cols-1 lg:grid-cols-2 items-center gap-12 mt-12">
        <LazyCardsFeature
          v-for="feature, index in props.items"
          :key="feature.title"
          :state="featureStyles[index]?.state"
          :vairant="featureStyles[index]?.vairant"
          :class="[
            index % 2 ? 'ml-auto' : 'mr-auto',
            index === 0 && 'py-10!',
            index === 2 && 'order-4 lg:order-3',
            index === 3 && 'order-3 lg:order-4 py-10!',
          ]"
          data-aos="fade-up" 
          data-aos-duration="1000"
        >
          <div class="flex flex-col gap-5">
            <h3>{{ feature.title }}</h3>
            <p v-html="feature.desc" />
            <NuxtImg
              width="450"
              height="450"
              :src="feature.img"
              :alt="feature.title"
              loading="lazy"
              class="w-full -mt-5"
            />
          </div>
        </LazyCardsFeature>
      </div>
    </SectionsBase>
</template>